// src/config.ts
// Einheitlich: immer relativer Pfad über Nginx-Proxy
// (egal ob lokal oder auf gto.kreativo24.de)
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || '/api';
